export const sms = [{ label: 'Msg 91', value: 0, code: 'S001' }]
